import React, { useCallback, useEffect } from "react";
import styles from "./contractor.module.scss";
import { cn } from "utils";
import Input from "components/Input";
import Checkbox from "components/Checkbox";
import Select from "components/Select";
import Radio from "components/Radio";
import Button from "components/Button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ContractorInputs, contractorSchema } from "./const";

const AddEditContractor = () => {
    const {
        register,
        handleSubmit,
        formState: {
            errors
        }
    } = useForm({
        resolver: yupResolver(contractorSchema)
    });

    useEffect(() => { console.log({ errors }) }, [errors])

    const onSubmit = useCallback((values) => {
        console.log("values", values);
    }, []);

    return (
        <form
            className={styles["add-edit-contractor-container"]}
            onSubmit={handleSubmit(onSubmit)}
        >
            <h3 className={styles["title"]}>Add Contractor</h3>
            <div className={styles["personal-info-container"]}>
                <p className={styles["info-title"]}>Personal Information</p>
                <div className={cn(styles["personal-info-form"], "")}>
                    <div className="row g-3">
                        <div className="col-lg-4 col-md-6 col-12">
                            <Input
                                fullWidth
                                label="First Name*"
                                variant="flat"
                                {...register(ContractorInputs.FIRSTNAME)}
                                error={!!errors[ContractorInputs.FIRSTNAME]}
                                errorText={errors[ContractorInputs.FIRSTNAME]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Input
                                fullWidth
                                label="Middle Name*"
                                variant="flat"
                                containerClasses="col"
                                {...register(ContractorInputs.MIDDLENAME)}
                                error={!!errors[ContractorInputs.MIDDLENAME]}
                                errorText={errors[ContractorInputs.MIDDLENAME]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Input
                                fullWidth
                                label="Last Name*"
                                variant="flat"
                                containerClasses="col"
                                {...register(ContractorInputs.LASTNAME)}
                                error={!!errors[ContractorInputs.LASTNAME]}
                                errorText={errors[ContractorInputs.LASTNAME]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Input
                                fullWidth
                                label="Contact Email*"
                                variant="flat"
                                containerClasses="col"
                                {...register(ContractorInputs.CONTACT_EMAIL)}
                                error={!!errors[ContractorInputs.CONTACT_EMAIL]}
                                errorText={errors[ContractorInputs.CONTACT_EMAIL]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Input
                                fullWidth
                                label="Contract Start Date*"
                                variant="flat"
                                type="date"
                                containerClasses="col"
                                {...register(ContractorInputs.CONTRACT_START_DATE)}
                                error={!!errors[ContractorInputs.CONTRACT_START_DATE]}
                                errorText={errors[ContractorInputs.CONTRACT_START_DATE]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Select
                                fullWidth
                                label="Payment Method"
                                placeholder="Select status"
                                options={[
                                    {
                                        label: "Online",
                                        value: "Online"
                                    },
                                    {
                                        label: "Offline",
                                        value: "Offline"
                                    },
                                ]}
                                {...register(ContractorInputs.PAYMENT_METHOD)}
                                error={!!errors[ContractorInputs.PAYMENT_METHOD]}
                                errorText={errors[ContractorInputs.PAYMENT_METHOD]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Select
                                fullWidth
                                label="Contractor Type"
                                placeholder="Select status"
                                options={[]}
                                {...register(ContractorInputs.CONTRACTOR_TYPE)}
                                error={!!errors[ContractorInputs.CONTRACTOR_TYPE]}
                                errorText={errors[ContractorInputs.CONTRACTOR_TYPE]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Input
                                fullWidth
                                label="Termination Date"
                                variant="flat"
                                type="date"
                                containerClasses="col"
                                {...register(ContractorInputs.TERMINATION_DATE)}
                                error={!!errors[ContractorInputs.TERMINATION_DATE]}
                                errorText={errors[ContractorInputs.TERMINATION_DATE]?.message}
                            />
                        </div>
                    </div>

                </div>
            </div>
            <div className={cn(styles["contract-info-container"], "mt-4")}>
                <p className={styles["info-title"]}>Contract Information</p>
                <form className={cn(styles["contract-info-form"], "container-fluid")}>
                    <div className="row g-3">
                        <div className="col-lg-4 col-md-6 col-12">
                            <Input
                                fullWidth
                                label="Street 1"
                                variant="flat"
                                placeholder="Enter an address"
                                {...register(ContractorInputs.STREET_1)}
                                error={!!errors[ContractorInputs.STREET_1]}
                                errorText={errors[ContractorInputs.STREET_1]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Input
                                fullWidth
                                label="Street 2"
                                variant="flat"
                                placeholder="Enter an address"
                                {...register(ContractorInputs.STREET_2)}
                                error={!!errors[ContractorInputs.STREET_2]}
                                errorText={errors[ContractorInputs.STREET_2]?.message}
                            />
                        </div>
                    </div>
                    <div className="row g-3 mt-3">
                        <div className="col-lg-4 col-md-6 col-12">
                            <Input
                                fullWidth
                                label="City*"
                                variant="flat"
                                {...register(ContractorInputs.CITY)}
                                error={!!errors[ContractorInputs.CITY]}
                                errorText={errors[ContractorInputs.CITY]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Select
                                fullWidth
                                label="State*"
                                placeholder="Select state"
                                options={[
                                    {
                                        label: "State 1",
                                        value: "State 1"
                                    },
                                    {
                                        label: "State 2",
                                        value: "State 2"
                                    },
                                ]}
                                {...register(ContractorInputs.STATE)}
                                error={!!errors[ContractorInputs.STATE]}
                                errorText={errors[ContractorInputs.STATE]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Input
                                fullWidth
                                label="Zip Code*"
                                variant="flat"
                                {...register(ContractorInputs.ZIP_CODE)}
                                error={!!errors[ContractorInputs.ZIP_CODE]}
                                errorText={errors[ContractorInputs.ZIP_CODE]?.message}
                            />
                        </div>
                    </div>
                </form>
            </div>
            <div className={cn(styles["work-info-container"], "mt-4")}>
                <p className={styles["info-title"]}>Work Information</p>
                <form className={cn(styles["work-info-form"], "container-fluid")}>
                    <h4 className={styles["label"]}>Primarily Work From Home</h4>
                    <div className={styles["radio-group"]}>
                        <Radio
                            value="yes"
                            label="Yes"
                            {...register(ContractorInputs.IS_WORK_FROM_HOME)}
                        />
                        <Radio
                            value="no"
                            label="No"
                            {...register(ContractorInputs.IS_WORK_FROM_HOME)}
                        />
                    </div>
                    <div className="row mt-3">
                        <div className="col-lg-4 col-md-6 col-12">
                            <Select
                                fullWidth
                                label="Work Location*"
                                options={[
                                    {
                                        label: "Springfiled, Indiana",
                                        value: "Springfiled, Indiana"
                                    },
                                ]}
                                {...register(ContractorInputs.WORK_LOCATION)}
                                error={!!errors[ContractorInputs.WORK_LOCATION]}
                                errorText={errors[ContractorInputs.WORK_LOCATION]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Select
                                fullWidth
                                label="Work Time Zone*"
                                options={[
                                    {
                                        label: "IST",
                                        value: "IST"
                                    },
                                ]}
                                {...register(ContractorInputs.WORK_TIME_ZONE)}
                                error={!!errors[ContractorInputs.WORK_TIME_ZONE]}
                                errorText={errors[ContractorInputs.WORK_TIME_ZONE]?.message}
                            />
                        </div>
                    </div>
                </form>
            </div>
            <div className={cn(styles["wage-info-container"], "mt-4")}>
                <p className={styles["info-title"]}>Wage Information</p>
                <form className={cn(styles["wage-info-form"], "container-fluid")}>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-12">
                            <Input
                                fullWidth
                                label="Wage*"
                                variant="flat"
                                {...register(ContractorInputs.WAGE)}
                                error={!!errors[ContractorInputs.WAGE]}
                                errorText={errors[ContractorInputs.WAGE]?.message}
                            />
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                            <Select
                                fullWidth
                                label="Wage Period"
                                options={[
                                    {
                                        label: "WP",
                                        value: "WP"
                                    },
                                ]}
                                {...register(ContractorInputs.WAGE_PERIOD)}
                                error={!!errors[ContractorInputs.WAGE_PERIOD]}
                                errorText={errors[ContractorInputs.WAGE_PERIOD]?.message}
                            />
                        </div>
                    </div>
                </form>
            </div>
            <div className={styles["bottom-container"]}>
                <Button buttonType="flat" type='submit'>Add Contractor</Button>
                <Button variant="text">Cancel</Button>
            </div>
        </form>
    )
}

export default AddEditContractor;